import { IUserInit } from '../interfaces/IUserInit';
import { DashboardUserRoute } from '../types/DashboardUserRouteTypes';

export class AdminInit implements IUserInit {
  private dashboardUserRoute: DashboardUserRoute = 'admin';

  public getDashboardUserRoute() {
    return this.dashboardUserRoute;
  }
}
